import { FC, useState } from "react";
import styles from "../Pricing.module.scss";
import cn from "classnames";
import Button from "./Button";
import { useHideDropdown } from "@hooks/useHideDropdown";
import { getScreenSize } from "@utils/getScreenSize";

const Sniper: FC = () => {
    const [sniperModalVisible, setSniperModalVisible] = useState(false);
    const [sniperModalItem, setSniperModalItem] = useState(0);
    const ref = useHideDropdown<HTMLDivElement>(setSniperModalVisible);
    const { isMobile } = getScreenSize();
    const handleSetSniperModalItem = (i: number) => {
        setSniperModalItem(i);
        setSniperModalVisible(false);
    };
    const sniperModalItems = [
        {
            name: "1 hour",
            price: "??",
            link: "https://",
        },
        {
            name: "1 day",
            price: "??",
            link: "https://",
        },
        {
            name: "1 week",
            price: "??",
            link: "https://",
        },
        {
            name: "1 month",
            price: "??",
            link: "https://",
        },
    ];
    return (
        <div className={styles.item}>
            <div className={cn(styles.itemBanner, styles.transparent)}>
                <h2 className={styles.itemHeadline}>Sniper</h2>
                <p className={styles.itemDescription}>Basic subscription to Sniper</p>
            </div>
            {isMobile && (
                <>
                    <div className={styles.priceHolder}>
                        <div ref={ref} className={styles.dropdownHolder}>
                            <button
                                onClick={() => setSniperModalVisible(!sniperModalVisible)}
                                className={styles.dropdown}
                            >
                                <span>{sniperModalItems[sniperModalItem].name}</span>
                                <img width={12} height={12} src="/images/pricing/down.svg" alt="" />
                            </button>
                            <ul
                                className={cn(styles.dropdownList, {
                                    [styles.active]: sniperModalVisible,
                                })}
                            >
                                {sniperModalItems.map(({ name }, i) => (
                                    <li key={name}>
                                        <button
                                            onClick={() => handleSetSniperModalItem(i)}
                                            className={styles.dropdownItem}
                                        >
                                            {name}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className={styles.price}>{sniperModalItems[sniperModalItem].price} TON</div>
                    </div>
                    <Button link={sniperModalItems[sniperModalItem].link} />
                </>
            )}
            <ul className={styles.list}>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Fast transaction</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Sniper mode</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Private community</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Communication with the project team</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Merch from Nest</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>3D NFT Model (Premium)</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>10% cashback from transactions</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/checked.svg" alt="" />
                    <span>Improved referral system</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Improved bonus system</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Project insights</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Whitelist of the presale</span>
                </li>
                <li className={styles.listItem}>
                    <img width={24} height={24} src="/images/pricing/minus.svg" alt="" />
                    <span>Partner projects advantages</span>
                </li>
            </ul>
            {!isMobile && (
                <>
                    <div className={styles.priceHolder}>
                        <div ref={ref} className={styles.dropdownHolder}>
                            <button
                                onClick={() => setSniperModalVisible(!sniperModalVisible)}
                                className={styles.dropdown}
                            >
                                <span>{sniperModalItems[sniperModalItem].name}</span>
                                <img width={12} height={12} src="/images/pricing/down.svg" alt="" />
                            </button>
                            <ul
                                className={cn(styles.dropdownList, {
                                    [styles.active]: sniperModalVisible,
                                })}
                            >
                                {sniperModalItems.map(({ name }, i) => (
                                    <li key={name}>
                                        <button
                                            onClick={() => handleSetSniperModalItem(i)}
                                            className={styles.dropdownItem}
                                        >
                                            {name}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className={styles.price}>{sniperModalItems[sniperModalItem].price} TON</div>
                    </div>
                    <Button link={sniperModalItems[sniperModalItem].link} />
                </>
            )}
        </div>
    );
};

export default Sniper;
